import AsyncButton from "@/components/AsyncButton";
import { Save } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useProjectStoreFormStore } from "../hooks/useProjectStoreFormStore";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../hooks/useCheckIsProjectLocked";

interface ProjectStoreSaveButtonProps {
  isLoading?: boolean;
}

export default function ProjectStoreSaveButton({
  isLoading = false,
}: ProjectStoreSaveButtonProps) {
  const { t } = useTranslation();
  const isSubmitting = useProjectStoreFormStore((s) => s.isSubmitting);
  const isDirty = useProjectStoreFormStore((s) => s.isDirty);
  const removeStoresWithoutPeriods = useProjectStoreFormStore(
    (s) => s.removeStoresWithoutPeriods,
  );
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();

  const disabled =
    isSubmitting ||
    !can_update ||
    isProjectLocked ||
    (!isDirty && !removeStoresWithoutPeriods);

  return (
    <AsyncButton
      type="submit"
      disabled={disabled}
      loadingLabel={t("commonEditor.toolbar.saving")}
      label={t("commonEditor.toolbar.save")}
      loading={isSubmitting || isLoading}
      icon={<Save className="mr-2 h-5 w-5" />}
    />
  );
}
